import * as z from "zod";
import { array, literal, number, object, string } from "zod";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseActionableComponentMessageSchema,
} from "../message-parser-utils";

export const WishlistItemSchema = object({
  productId: string(),
  variantId: string().optional(),
  title: string().optional(),
  imageUrl: string().optional(),
  price: string().optional(),
  url: string().optional(),
});

export type WishlistItem = z.infer<typeof WishlistItemSchema>;

export const WishlistStructuredContentSchema = object({
  items: array(WishlistItemSchema),
  itemCount: number(),
});

export type WishlistStructuredContent = z.infer<
  typeof WishlistStructuredContentSchema
>;

export const WishlistMessageSchema =
  BaseActionableComponentMessageSchema.extend({
    contentType: literal(ContentType.WISHLIST_DISPLAY),
    structuredContent: WishlistStructuredContentSchema.optional(),
  });

export const WishlistMessageDbParser = WishlistMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);

export type WishlistMessageType = z.infer<typeof WishlistMessageDbParser>;
